import React from 'react'
import { Box } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { useDevicePairing } from '../../hooks'
import { PairingButton, OptionalFields, SectionHeading } from 'src/Libs/flow/components'
import { InstallationFormModel } from 'src/Libs/flow/installation/forms'
import { TextField } from 'src/Libs/inputs/react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
export const Emc: React.FC = () => {
  const { t } = useCustomTranslation()
  const { control } = useInstallationForm()
  const emc = useWatch({ control, name: 'emcDevice' })
  const { canPair, handlePairing } = useDevicePairing(emc)
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  return (
    <OptionalFields<InstallationFormModel> condition={emc !== null} fieldNames={['emcDevice']}>
      <section id={emc?.navigationId ?? ''}>
        <SectionHeading title={t('installation.types.emc')} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ minWidth: { xs: '100%', sm: 'auto' } }}>
            <SettingsBox
              title={'common.name'}
              suffix={
                <Box sx={{ minWidth: { xs: '100%', sm: 'auto' } }}>
                  <TextField name="emcDevice.name" label={t('common.name')} disabled fullWidth />
                </Box>
              }
            />
            <SettingsBox
              title={'productEditor.pairingEditor.pairingID.emc'}
              suffix={
                <Box sx={{ minWidth: { xs: '100%', sm: 'auto' } }}>
                  <TextField name="emcDevice.pairingId" label={t('productEditor.pairingEditor.pairingID.emc')} disabled fullWidth />
                </Box>
              }
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <PairingButton
              size="large"
              sx={{ height: '100%', width: { xs: '100%', md: 'auto' } }}
              icon={emc?.pairingId ? 'transfer' : 'link'}
              disabled={!canPair || !canEdit}
              onClick={handlePairing}
            >
              {t(getButtonPairingKey(emc?.deviceId, emc?.pairingId))}
            </PairingButton>
          </Box>
        </Box>
      </section>
    </OptionalFields>
  )
}

const getButtonPairingKey = (deviceId?: string, pairingId?: string): string => {
  if (deviceId) return 'common.edit'
  if (pairingId) return 'common.replace'
  return 'common.pair'
}
